"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const StringLengthError_1 = require("../errors/StringLengthError");
const noError_1 = require("../helpers/noError");
const stringLengthError = (length, rule, key) => {
    const error = {
        type: StringLengthError_1.StringLengthErrorType,
        key: key,
        length: length,
        minLength: rule.minLength,
        maxLength: rule.maxLength,
    };
    return {
        error: error,
    };
};
exports.validateStringLength = (rule) => (value, key) => {
    const length = value.length;
    if (rule.minLength !== undefined && length < rule.minLength) {
        return stringLengthError(length, rule, key);
    }
    if (rule.maxLength !== undefined && length > rule.maxLength) {
        return stringLengthError(length, rule, key);
    }
    return noError_1.noError();
};
//# sourceMappingURL=validateStringLength.js.map